// SPDX-License-Identifier: GPL-3.0-or-later

type Attrs = Record<string, string | number | boolean | EventListener | null | undefined>;
type Child = Node | string | number | false | null | undefined;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (value === null || value === undefined || value === false) continue;
    if (key.startsWith('on') && typeof value === 'function') {
      node.addEventListener(key.slice(2).toLowerCase(), value as EventListener);
    } else if (key === 'class' && typeof value === 'string') {
      node.className = value;
    } else if (key === 'html' && typeof value === 'string') {
      node.innerHTML = value;
    } else {
      node.setAttribute(key, String(value));
    }
  }
  for (const child of children) {
    if (child === false || child === null || child === undefined) continue;
    node.appendChild(typeof child === 'string' || typeof child === 'number'
      ? document.createTextNode(String(child))
      : child);
  }
  return node;
}

export function clear(node: Element): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

export function mount(root: Element, view: Element): void {
  clear(root);
  root.appendChild(view);
}
